module.exports = __webpack_public_path__ + "img/style_swiper_05.f7e70b52.png";